<template>
  <v-theme-provider light>
    <base-section
      id="html-disclaimer-content"
      space="40"
    >
      <v-container>
        <v-row
          class=""
        >
          <v-col
            class="intro-text"
            cols="12"
            sm="12"
            md="9"
          >
            <h2
              class="my-4"
            >
              Non-Reliance Disclaimer
            </h2>
            <p>
              Hypothetical or simulated performance is not indicative of future results. Unless explicitly noted otherwise, all profit examples provided in our websites and publications are based on hypothetical or simulated trading, which means they are completed on paper or electronically based on real market prices at the period the recommendation is disseminated to the user of this service, but without actual money being invested. Also, such examples do not include the costs of subscriptions, commissions, and additional fees, or examples of additional recommendations as to which there were losses using the timing at the period of the recommendations.
            </p>
            <p>
              Honely, LLC calculates estimates off their Automated Valuation Models (AVMs), but these may not be relied on and are not intended to replace specific, live, on-site appraisals. Many variables exist in home valuation, and we do not represent that the data provided on this website is complete, accurate or predictive of actual sales and costs.
            </p>
            <p>
              The data, products and services on this web site are provided on an "AS IS," "WHERE IS" and "WHERE AVAILABLE" basis. Honely, LLC does not warrant the data or services provided herein or your usage of this web site generally, either expressly or impliedly, for any particular purpose and expressly disclaims any implied warranties, including but not limited to, warranties of title, non-infringement, merchantability or fitness for a particular purpose. Honely, LLC will not be liable for any loss or damage that could result from interception by third parties of any information or services made available to you via this web site. Although the information provided to you on this web site is obtained or compiled from sources we believe to be reliable, Honely, LLC cannot and does not guarantee the accurateness, validity, timeliness or completeness of any data or information made available to you for any particular purpose. Neither Honely, LLC, nor any of its affiliates, directors, officers or employees, nor any third party vendor, will be liable or have any responsibility of any kind for any loss or damage that you incur in the event of any failure or interruption of this web site, or resulting from the act or omission of any other party involved in making this web site, the data contained herein or the products or services offered on this web site available to you, or from any other cause relating to your access to, inability to access, or use of the web site or these materials, whether or not the situations giving rise to such cause could have been within the control of Honely, LLC or of any vendor providing software or services. In no event will Honely, LLC or any such parties be responsible to you, whether in contract or tort, for any direct, special, indirect, consequential or incidental damages or any other damages of any kind even if Honely, LLC or any other such party has been advised of the possibility thereof. This limitation on liability includes, but is not limited to, the transmission of any viruses which could infect a user's equipment, failure of mechanical or electronic equipment or communication lines, telephone or other interconnect issues (e.g., you cannot access your internet service provider), unauthorized access, theft, operator errors, strikes or other labor problems or any force majeure. Honely, LLC cannot and does not guarantee continuous, uninterrupted or secure access to the web site.
            </p>
            <p>
              All or some of the products offered on Honely.com are from third party vendors and other sources, from which Honely.com may receive compensation. Products referenced may include those from such third party sources, who list available products in sequence and selection not determined by Honely, LLC. We do not include all companies or all types of products available in a given marketplace.
            </p>
            <p>
              Subscribers may submit inquiries to Honely, LLC directly through the website.
            </p>
          </v-col>
        </v-row>
      </v-container>
    </base-section>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'DisclaimerContent',

    provide: {
      theme: { isDark: true },
    },

  }
</script>

<style lang="sass">
  #html-disclaimer-content
    p, li
      font-family: $body-font-family

      span
        font-weight: 600
        color: black

    ul
      margin-bottom: 10px

    .gray-med
      color: $color-gray-med

    .privacy-table
      border: 1px solid $color-gray-lt
      border-bottom: none
      font-family: $body-font-family

      .left-column
        border-right: 1px solid $color-gray-lt

      span
        font-weight: 600
        // font-style: italic

    .privacy-table:last-child
      border-bottom: 1px solid $color-gray-lt

    .table-content.v-card, #privacy-table-footer
      border-bottom: 1px solid $color-gray-lt

    .table-content.v-card:last-child
      border-bottom: none

    .yes-no.yn-two
      border-left: 1px solid $color-gray-lt

    .individual-data
      .bottom-row
        border-bottom: 1px solid $color-gray-lt

    ul.bold-copy>li
      font-weight: 600
      text-transform: uppercase

      span
        font-style: italic

      ul, p
        font-weight: 400
        text-transform: none

    ul.li-spaced>li
      margin-bottom: 10px

</style>
